import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Lazy-load react-ga4 to reduce initial bundle size
let ReactGA: any = null;
let gaInitialized = false;

async function initGA() {
  if (gaInitialized) return;
  const host = window.location.hostname;
  if (host === "localhost") return;

  try {
    const module = await import("react-ga4");
    ReactGA = module.default;
    ReactGA.initialize("G-767H2Q7V9Q");
    gaInitialized = true;
  } catch (error) {
    console.warn("Failed to load analytics:", error);
  }
}

export default function Analytics(props: any) {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA on first mount
    initGA();
  }, []);

  useEffect(() => {
    const host = window.location.hostname;
    if (host !== "localhost" && ReactGA) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
        title: "C: " + document.title,
      });
    }
  }, [location]);

  return <>{props.children}</>;
}
